import NavLink from '../navLink'

const ContactButton = ({ className, name, icon, onClick = () => {}, url = '/' }) => (
  <NavLink to={url}>
    <button
      className={`px-2 lg:px-[33px] lg:py-[18px] min-w-[140px] flex flex-wrap justify-center lg:justify-between items-center ${className}`}
      onClick={onClick}
    >
      <img className="hidden lg:block" style={{ width: 30, height: 30 }} src={icon} alt="" />
      <img className="block lg:hidden" style={{ width: 24, height: 26 }} src={icon} alt="" />
      <span className="ml-4 lg:ml-10 text-white font-alhpr text-xl">{name}</span>
    </button>
  </NavLink>
)

export default ContactButton
